import { render, staticRenderFns } from "./ExcludeObjects.vue?vue&type=template&id=5ced8bf2&scoped=true&"
import script from "./ExcludeObjects.vue?vue&type=script&lang=ts&"
export * from "./ExcludeObjects.vue?vue&type=script&lang=ts&"
import style0 from "./ExcludeObjects.vue?vue&type=style&index=0&id=5ced8bf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ced8bf2",
  null
  
)

export default component.exports